<template>
    <div class="spark-docs-ad-popup-contacts">
        <div class="spark-docs-ad-popup-contacts__container">
            <div class="container__header">
                <div class="header__title">Успейте первыми!</div>
                <div class="header__description">Получите наш продукт до конца года <span>абсолютно бесплатно!</span></div>

                <a class="header__readmore" href="/banners/Spark Docs.pdf" target="_blank">
                    <svg class="readmore__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.3335 13.3334L3.3335 14.1667C3.3335 15.5475 4.45278 16.6667 5.8335 16.6667L14.1668 16.6667C15.5475 16.6667 16.6668 15.5475 16.6668 14.1667L16.6668 13.3334M13.3335 10.0001L10.0002 13.3334M10.0002 13.3334L6.66683 10.0001M10.0002 13.3334L10.0002 3.33342" stroke="#253EEB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                    <div class="readmore__text">Подробнее о Spark Docs</div>
                </a>
            </div>

            <div class="container__footer">
                <div class="footer__social">
                    <a href="https://api.whatsapp.com/send/?phone=77072210765&text&type=phone_number&app_absent=0" target="_blank" rel="noopener nofollow noreferrer">
                        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.175 24.9125C15.3 25.5875 16.65 25.925 18 25.925C22.1625 25.925 25.425 22.55 25.425 18.6125C25.425 16.5875 24.75 14.7875 23.2875 13.325C21.825 11.975 20.025 11.1875 18 11.1875C13.95 11.1875 10.575 14.5625 10.575 18.6125C10.575 19.9625 10.9125 21.3125 11.7 22.55L11.925 22.8875L11.1375 25.5875L13.95 24.8L14.175 24.9125ZM20.475 19.625C20.7 19.625 21.825 20.1875 22.05 20.3C22.085 20.3175 22.1201 20.3323 22.1547 20.3469C22.3423 20.4261 22.5175 20.5001 22.6125 20.975C22.725 20.975 22.725 21.425 22.5 21.9875C22.3875 22.4375 21.4875 23 21.0375 23C20.9613 23 20.8883 23.0065 20.8103 23.0134C20.4279 23.0472 19.926 23.0916 18.3375 22.4375C16.366 21.6489 14.9991 19.7374 14.6152 19.2006C14.561 19.1248 14.5264 19.0764 14.5125 19.0625C14.4933 19.0242 14.4546 18.9631 14.4035 18.8824C14.1547 18.4895 13.6125 17.6335 13.6125 16.7C13.6125 15.575 14.175 15.0125 14.4 14.7875C14.625 14.5625 14.85 14.5625 14.9625 14.5625H15.4125C15.525 14.5625 15.75 14.5625 15.8625 14.9C16.0875 15.35 16.5375 16.475 16.5375 16.5875C16.5375 16.625 16.55 16.6625 16.5625 16.7C16.5875 16.775 16.6125 16.85 16.5375 16.925C16.4813 16.9812 16.4531 17.0375 16.425 17.0938C16.3969 17.15 16.3688 17.2063 16.3125 17.2625L15.975 17.6C15.8625 17.7125 15.75 17.825 15.8625 18.05C15.975 18.275 16.425 19.0625 17.1 19.625C17.8595 20.2896 18.4588 20.5535 18.7626 20.6874C18.8188 20.7121 18.8649 20.7324 18.9 20.75C19.125 20.75 19.2375 20.75 19.35 20.6375C19.4063 20.525 19.5469 20.3563 19.6875 20.1875C19.8281 20.0187 19.9687 19.85 20.025 19.7375C20.1375 19.5125 20.25 19.5125 20.475 19.625Z" fill="#253EEB"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.125C0 3.0184 2.5184 0.5 5.625 0.5H30.375C33.4816 0.5 36 3.0184 36 6.125V30.875C36 33.9816 33.4816 36.5 30.375 36.5H5.625C2.5184 36.5 0 33.9816 0 30.875V6.125ZM18 9.5C20.3625 9.5 22.6125 10.4 24.3 12.0875C25.9875 13.775 27 16.025 27 18.3875C27 23.3375 22.95 27.3875 18 27.3875C16.5375 27.3875 15.075 26.9375 13.725 26.2625L9 27.5L10.2375 23C9.45001 21.65 9 20.075 9 18.5C9 13.55 13.05 9.5 18 9.5Z" fill="#253EEB"/>
                        </svg>
                    </a>

                    <a href="https://www.instagram.com/spark.kz?igsh=OGFxa3dnZnJ3ZjFo" target="_blank" rel="noopener nofollow noreferrer">
                        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="0.5" width="36" height="36" rx="8" fill="#253EEB"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 18.5C9 14.9049 9 13.1073 9.85669 11.8126C10.2392 11.2344 10.7344 10.7392 11.3126 10.3567C12.6073 9.5 14.4049 9.5 18 9.5C21.5951 9.5 23.3927 9.5 24.6874 10.3567C25.2656 10.7392 25.7608 11.2344 26.1433 11.8126C27 13.1073 27 14.9049 27 18.5C27 22.0951 27 23.8927 26.1433 25.1874C25.7608 25.7656 25.2656 26.2608 24.6874 26.6433C23.3927 27.5 21.5951 27.5 18 27.5C14.4049 27.5 12.6073 27.5 11.3126 26.6433C10.7344 26.2608 10.2392 25.7656 9.85669 25.1874C9 23.8927 9 22.0951 9 18.5ZM22.6593 18.5002C22.6593 21.0735 20.5732 23.1596 17.9998 23.1596C15.4265 23.1596 13.3404 21.0735 13.3404 18.5002C13.3404 15.9269 15.4265 13.8408 17.9998 13.8408C20.5732 13.8408 22.6593 15.9269 22.6593 18.5002ZM17.9998 21.5832C19.7025 21.5832 21.0828 20.2029 21.0828 18.5002C21.0828 16.7975 19.7025 15.4172 17.9998 15.4172C16.2971 15.4172 14.9168 16.7975 14.9168 18.5002C14.9168 20.2029 16.2971 21.5832 17.9998 21.5832ZM22.8433 14.7015C23.4479 14.7015 23.9381 14.2114 23.9381 13.6067C23.9381 13.0021 23.4479 12.5119 22.8433 12.5119C22.2386 12.5119 21.7485 13.0021 21.7485 13.6067C21.7485 14.2114 22.2386 14.7015 22.8433 14.7015Z" fill="#F6F5F8"/>
                        </svg>
                    </a>
                </div>

                <div class="footer__contacts">
                    <div class="contacts__title">Контакты</div>

                    <a href="tel:+77072210765" class="contacts__contact">
                        +7 707 221 07 65  - Асель
                    </a>
                </div>

                <div class="footer__address">
                    <div class="address__title">Наш адрес</div>
                    <p>г. Алматы</p>
                    <p>ул. Мамбетова 1/57 (ул. Момышулы 1а/57)</p>
                    <p>050012/A05H0E3</p>
                </div>
            </div>
        </div>

        <img class="spark-docs-ad-popup-contacts__img" alt="Spark Docs" src="/banners/spark-docs-ad.png" style="user-select: none;" draggable="false" />
    </div>
</template>

<style lang="scss" scoped>
.spark-docs-ad-popup-contacts {
    min-height: 468px;
    padding: 24px;
    border-radius: 12px;
    background-color: #EFF3FF;
    color: #253EEB;

    position: relative;

    &__container {
        position: relative;
        z-index: 2;

        height: 100%;
        width: 100%;
        max-width: 300px;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 16px;

        & .container__header {
            & .header__title {
                font-size: 32px;
                font-weight: 700;
            }

            & .header__description {
                margin-top: 8px;

                font-size: 18px;
                font-weight: 400;

                & span {
                    font-weight: 700;
                }
            }

            & .header__readmore {
                color: inherit;
                margin-top: 8px;
                display: flex;
                align-items: center;
                gap: 8px;
                font-weight: 500;

                cursor: pointer;

                & .readmore__icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                & .readmore__text {
                    line-height: 1;
                    text-decoration: underline;
                }
            }
        }

        & .container__footer {
            & .footer__social {
                display: flex;
                align-items: center;
                gap: 16px;
            }

            & .footer__contacts {
                margin-top: 24px;

                & .contacts__title {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 28.8px;
                }

                & .contacts__contact {
                    font-weight: 400;
                }
            }

            & .footer__address {
                margin-top: 24px;

                & .address__title {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 28.8px;
                }

                & p {
                    font-weight: 400;
                }
            }
        }
    }

    &__img {
        display: none;
        position: absolute;
        bottom: 0;
        right: 0;
    }
}

@media screen and (min-width: 546px) {
    .spark-docs-ad-popup-contacts {
        &__img {
            display: block;
        }
    }
}
</style>